<template>
  <svg
    id="Money-Sharing-Give--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <desc>Money Sharing Give Streamline Icon: https://streamlinehq.com</desc>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M4 1c0 -0.552285 0.44772 -1 1 -1h18c0.5523 0 1 0.447715 1 1v12c0 0.5523 -0.4477 1 -1 1h-8.4019c-0.0321 -0.0555 -0.0661 -0.1103 -0.1019 -0.1641l-0.4056 -0.6083 -0.0007 -0.0011C13.1626 11.8355 11.6014 11 9.92964 11H9L6 8v3H4V1Zm10 8c1.1046 0 2 -0.89543 2 -2s-0.8954 -2 -2 -2 -2 0.89543 -2 2 0.8954 2 2 2Zm8 -3 -4 -4h4v4Zm-4 6 4 -4v4h-4ZM10 2 6 6V2h4Zm0.7575 21.9701L0 21.2808V13h9.92964c1.00306 0 1.93976 0.5013 2.49616 1.3359l0.4063 0.6094c0.2045 0.3069 0.2236 0.7014 0.0496 1.0266 -0.174 0.3251 -0.5129 0.5281 -0.8817 0.5281H8v2h11.9254c1.1458 0 2.0746 0.9288 2.0746 2.0746 0 1.0269 -0.7513 1.8993 -1.7668 2.0516l-9.0849 1.3627c-0.1302 0.0196 -0.2631 0.0132 -0.3908 -0.0188Z"
      clip-rule="evenodd"
      stroke-width="1"
    />
  </svg>
</template>
